import { render, staticRenderFns } from "./SingleClientView.vue?vue&type=template&id=a2148f7c&scoped=true"
import script from "./SingleClientView.vue?vue&type=script&lang=js"
export * from "./SingleClientView.vue?vue&type=script&lang=js"
import style0 from "./SingleClientView.vue?vue&type=style&index=0&id=a2148f7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2148f7c",
  null
  
)

export default component.exports